module.exports = __webpack_public_path__ + "img/198.92adbd34.jpg";